/**
 * Age from a "YYYY-MM-DD" birth date, in UTC — the same rule as the server's ageOn()
 * (services/confidentialityWaiver.ts): a birthday not yet reached this year counts one less.
 */
export function ageOn(birthDate: string, now: Date = new Date()): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate.trim())
  if (!m) return null
  const year = Number(m[1]), month = Number(m[2]) - 1, day = Number(m[3])
  let age = now.getUTCFullYear() - year
  const dm = now.getUTCMonth() - month
  if (dm < 0 || (dm === 0 && now.getUTCDate() < day)) age -= 1
  return age
}

/** Under 18 today. An unknown or malformed birth date is not treated as a minor. */
export function isMinor(birthDate: string | null | undefined, now: Date = new Date()): boolean {
  if (!birthDate) return false
  const age = ageOn(birthDate, now)
  return age !== null && age >= 0 && age < 18
}

/**
 * Minors (Italy): both parents sign the informed consent. One signature is enough only in these
 * cases (Arne, 2026-10-26); the same values as server/src/utils/parentalSignature.ts.
 */
export const SINGLE_SIGNATURE_REASONS = [
  'sole_custody_restricted',
  'parental_responsibility_terminated',
  'single_parent',
] as const

export type SingleSignatureReason = (typeof SINGLE_SIGNATURE_REASONS)[number]
